import { Link } from 'react-router-dom';
import { FaDice, FaCompass, FaUpload, FaHandshake } from 'react-icons/fa';
import '../styles/Footer.css';

const Footer = () => {
  return (
    <footer className="footer" role="contentinfo">
      <div className="footer-content">
        {/* Top row: branding + navigation columns */}
        <div className="footer-grid">
          {/* Branding column */}
          <div className="footer-brand-col">
            <span className="footer-brand-name">Table Top Archive</span>
            <p className="footer-tagline">
              Discover, share, and borrow board games from your community.
            </p>
          </div>

          {/* Quick Links column */}
          <div className="footer-nav-col">
            <h4 className="footer-col-title">Explore</h4>
            <nav aria-label="Footer explore links">
              <Link to="/market" className="footer-nav-link">
                <FaDice /> Browse Games
              </Link>
              <Link to="/discover" className="footer-nav-link">
                <FaCompass /> Discover
              </Link>
              <Link to="/upload" className="footer-nav-link">
                <FaUpload /> Upload a Game
              </Link>
              <Link to="/borrow" className="footer-nav-link">
                <FaHandshake /> Borrow
              </Link>
            </nav>
          </div>

          {/* Info column */}
          <div className="footer-nav-col">
            <h4 className="footer-col-title">Info</h4>
            <nav aria-label="Footer info links">
              <Link to="/terms-of-service" className="footer-nav-link">
                Terms of Service
              </Link>
              <Link to="/privacy-policy" className="footer-nav-link">
                Privacy Policy
              </Link>
            </nav>
          </div>
        </div>

        {/* Separator */}
        <hr className="footer-separator" />

        {/* Bottom row: copyright + BGG */}
        <div className="footer-bottom">
          <span className="footer-copyright">
            &copy; {new Date().getFullYear()} Table Top Archive. All rights
            reserved.
          </span>

          <div className="footer-bgg-inline">
            <a
              href="https://boardgamegeek.com"
              target="_blank"
              rel="noopener noreferrer"
              className="bgg-logo-link"
              aria-label="Powered by BoardGameGeek"
            >
              <svg
                className="bgg-logo"
                width="120"
                height="28"
                viewBox="0 0 120 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <rect width="120" height="28" rx="4" fill="#FF5100" />
                <text
                  x="10"
                  y="19"
                  fontFamily="Arial, sans-serif"
                  fontSize="12"
                  fontWeight="bold"
                  fill="white"
                >
                  Powered by BGG
                </text>
              </svg>
            </a>
            <span className="bgg-copyright">
              Game data &copy; BoardGameGeek
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
